import { aplicarTema, temaGuardado } from './lib/tema.js';
import { useEffect } from 'react';
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
} from 'react-router';
import { AuthProvider } from './lib/auth.js';
import { OrgProvider } from './lib/org.js';
import { ProveedorDeDialogos } from './lib/dialogos.js';
import { CodeDetail } from './routes/CodeDetail.js';
import { Codes } from './routes/Codes.js';
import { CompleteSignIn } from './routes/CompleteSignIn.js';
import { Facturacion } from './routes/Facturacion.js';
import { Layout } from './routes/Layout.js';
import { SignIn } from './routes/SignIn.js';
import { Superadmin } from './routes/Superadmin.js';
import { Team } from './routes/Team.js';
import { AcceptInvite } from './routes/AcceptInvite.js';

/** Las rutas que no son el panel, sino la puerta de entrada. */
const RUTAS_DE_ACCESO = /^\/(acceso|invitacion)/;

/**
 * Las pantallas de acceso van siempre en tema claro.
 *
 * No es un capricho: son la costura con la pagina publica, que tampoco cambia
 * de tema, y lo que se ve ahi es el cartel de la marca sobre su indigo. El
 * panel, que es una herramienta de uso diario, si sigue al sistema.
 *
 * El primer pintado lo resuelve un script en index.html; esto se encarga de
 * mantenerlo al navegar dentro de la aplicacion, que es cuando React manda.
 */
function TemaDeLaRuta() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!RUTAS_DE_ACCESO.test(pathname)) {
      /*
       * Dentro del panel manda lo que el usuario eligio, que por defecto es
       * seguir al sistema. Antes aqui se borraba el atributo a secas, lo que
       * imponia el tema del sistema y pisaba la eleccion al volver del acceso.
       */
      aplicarTema(temaGuardado());
      return;
    }
    // La puerta de entrada va siempre en claro: ver apps/admin/src/lib/tema.ts.
    document.documentElement.setAttribute('data-theme', 'light');
  }, [pathname]);

  return null;
}

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <OrgProvider>
          <ProveedorDeDialogos>
            <TemaDeLaRuta />
            <Routes>
              {/* Publicas: no requieren sesion iniciada. */}
              <Route path="/acceso" element={<SignIn />} />
              <Route path="/acceso/completar" element={<CompleteSignIn />} />
              <Route path="/invitacion" element={<AcceptInvite />} />

              {/* Panel: Layout hace de guardia y redirige si no hay sesion. */}
              <Route element={<Layout />}>
                <Route index element={<Codes />} />
                <Route path="/codigos/:codeId" element={<CodeDetail />} />
                <Route path="/equipo" element={<Team />} />
                <Route path="/facturacion" element={<Facturacion />} />
                <Route path="/superadmin" element={<Superadmin />} />

                {/*
                  Cualquier otra direccion vuelve a la lista.

                  Sin esto, una direccion equivocada —un marcador viejo, un
                  enlace mal copiado, una letra de mas— pintaba una pantalla
                  negra y vacia, sin mensaje y sin salida, que es exactamente lo
                  que parece un producto roto. No se le pone una pagina de "no
                  encontrado" porque aqui no hay nada que explicar: el panel
                  tiene tres sitios y el que se busca es siempre uno de ellos.
                */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Route>
            </Routes>
          </ProveedorDeDialogos>
        </OrgProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
